export default __webpack_public_path__ + "static/media/el_1.6bd57743.mp3";